import { render, staticRenderFns } from "./VList.vue?vue&type=template&id=358069af&lang=pug&"
import script from "./VList.vue?vue&type=script&lang=js&"
export * from "./VList.vue?vue&type=script&lang=js&"
import style0 from "./VList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports